import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';

interface CopyButtonProps {
  value: string;
}

const CopyButton = ({ value }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <ActionButton
            tone="ghost"
            size="xs"
            iconOnly
            aria-label={copied ? 'Skopiowano' : 'Kopiuj'}
            onClick={handleCopy}
          >
            {copied ? <Check /> : <Copy />}
          </ActionButton>
        </span>
      </TooltipTrigger>
      <TooltipContent>{copied ? 'Skopiowano' : 'Kopiuj'}</TooltipContent>
    </Tooltip>
  );
};

export default CopyButton;
